export default __webpack_public_path__ + "static/media/IHP.c51e9fe0.jpg";